import styled from 'styled-components';
import { Colors, Font, ScreenWidth, Spacing } from 'web-common/src/shared/styles';

export const ShefInfoContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Container = styled.div<{ bgColor: string; borderColor: string | null }>`
  background: ${(props) => props.bgColor};
  ${(props) => `border-bottom: 1px solid ${props.borderColor};`}
  padding: ${Spacing.SINGLE} ${Spacing.SINGLE_HALF};

  @media (max-width: ${ScreenWidth.SMALL}) {
    padding: ${Spacing.HALF} ${Spacing.SINGLE};
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const MessageContainer = styled.div`
  margin-top: ${Spacing.SINGLE};
  text-align: center;
`;

export const Title = styled.p`
  font-family: ${Font.Family.SANS};
  font-weight: ${Font.Weight.SEMI_BOLD};
  font-size: ${Font.Size.XS};
  color: ${Colors.GRAY_DARK_30};
  margin: 0 0 0 ${Spacing.HALF};
`;

export const ProfilePhoto = styled.div`
  background: ${Colors.GRAY_LITE_20};
  display: flex;
  overflow: hidden;
  border-radius: 50%;
  width: 32px;
  height: 32px;
`;

export const MenuLink = styled.button`
  font-family: ${Font.Family.SANS};
  font-weight: ${Font.Weight.SEMI_BOLD};
  font-size: ${Font.Size.XS};
  color: ${Colors.GRAY_DARK_30};
  text-decoration: underline;
  background: none;
  border: none;
  display: block;

  &:disabled {
    color: ${Colors.GRAY_DARK_20};
    text-decoration: none;
    cursor: not-allowed;
  }
`;
